import { useEffect } from 'react'
import classes from './preview-fallback.module.css'

export function PreviewFallback() {
  useEffect(() => {
    document.querySelector('[data-testid="tidal-sandbox_preview"]')?.removeAttribute('data-sandbox-story-loaded')
    return () => {
      document.querySelector('[data-testid="tidal-sandbox_preview"]')?.setAttribute('data-sandbox-story-loaded', '')
    }
  }, [])

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <Skeleton />
        <Skeleton className={classes.delay1} />
        <Skeleton className={classes.delay2} />
        <Skeleton className={classes.delay3} />
      </div>
    </div>
  )
}

type SkeletonProps = {
  className?: string
}
function Skeleton(props: SkeletonProps) {
  const { className } = props
  const cls = className ? `${classes.skeleton} ${className}` : classes.skeleton
  return <div className={cls} />
}
